import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RepresentacaoEmpresaService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllRepresentacaoEmpresa`,
      this.getParams(params),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getRepresentacaoEmpresaById/${id}`,
      this.getParams(),
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddRepresentacaoEmpresa`,
      data,
      {},
      true
    );
  }
  addRange(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddRepresentacaoEmpresaRange`,
      data,
      {},
      true
    );
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateRepresentacaoEmpresa`,
      data,
      this.getParams(),
      true
    );
  }
  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteRepresentacaoEmpresaById/${id}`,
      this.getParams(),
      true
    );
  }
  getPhoto(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getPhotoRepresentacaoEmpresa/${id}`,
      this.getParams(),
      true
    );
  }
  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}